import Accordion from './Accordion.vue';
export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/index.ts